import { navigate } from 'gatsby'

const navigateTo = (to) => {
  if (to.startsWith('/')) {
    navigate(to)
  } else {
    window.location.href = to
  }
}

export default navigateTo
